// extracted by mini-css-extract-plugin
module.exports = {"integral-goods-of-leval":"integral-goods-of-leval-b91b890b3519f0ecd3bd435164dbc317"};